export const ESTABLISHMENTS = "/api/pa/Reference/Schools"
export const ESTABLISHMENT = "/api/pa/Reference/School/:param"
